module.exports = __webpack_public_path__ + "static/media/banner-feria-empresarial-la-montana-movile.5d9085f5.webp";